
<div [ngClass]="{'pe-featuredProducts':true,'pe-no-margin':item.data.fullWidth}"
     [ngStyle]="{maxWidth:layoutSetting.maxWidth + 'px'}">
  <app-sub-component-container [layoutSetting]="layoutSetting" [item]="item">
    <div class="pe-f-header">
      {{ item.data.header}}
    </div>
    <div class="pe-f-description">
      {{item.data.description}}
    </div>
    <div class="pe-f-list front-wrap">
      <div class="row">
        <div class="col-sm-6 col-lg-4" *ngFor="let product of products; index as i">
          <div class="store-item">
            <div class="store-item-thumb">
              <span class="dec-type">{{product.CustomizationType}}</span>
              <div class="cstm-prdct display-table">
                <div class="display-cell">
                  <div (click)="viewOnly && fn_ViewProduct(storeName,product.ProductId, product.DesignId, 1)">                         
                    <img *ngIf="!product.ImgLoaded" src="/assets/img/load-spinner.gif" alt="loading" />
                    <img [src]="product.Img || 'assets/img/no-image-available.jpg'" [hidden]="!product.ImgLoaded" (load)="product.ImgLoaded=true">
   
                  </div>
                  <div class="store-item-cntnt">
                    <h4>{{product.Name}}</h4>
                    <h4 class="text-info">{{product.CustomizationType}}</h4>
                  </div>

                  <!-- Farbe und GroBe  -->
                  <div class="available-sizes store-item-cntnt">
                    <span *ngFor="let sz of product.Sizes">
                      <span> {{sz.Name}}</span>
                    </span>
                  </div>
                  <div class="color-list store-item-cntnt tick">
                    <!--Conditional based isActive display-->
                    <ng-container *ngFor="let s of product.ColorList">
                      <!--[ngClass]="{'selected-style':s.ID == s.StyleId}"-->
                      <div title="{{s.ColorName}}" class="available-colors"
                           *ngIf="s.IsActive"
                           [ngStyle]="displayColor( s.ColorHexCode)"
                           [ngClass]="{'selected-style':s.StyleId == product.StyleId}"
                           data-tooltip="s.ColorName"
                           (click)="selectStyleToCustomize(s, i)">
                      </div>
                      <div title="{{s.ColorName}} ***Discontinued" class="available-colors discontinuedColor"
                           *ngIf="!s.IsActive"
                           [ngStyle]="displayColor(s.ColorHexCode)"
                           [ngClass]="{'selected-style':s.StyleId == product.StyleId}"
                           data-tooltip="s.ColorName"
                           (click)="selectStyleToCustomize(s, i)">
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <button [disabled]="!product.ProductId" *ngIf="!viewOnly"
                  mat-button type="button" class="mat-btn mat-red"
                  (click)="fn_RemoveProduct(product.ProductId, product.DesignId)" title="Buy Now" style="margin-top:5px;">
            Remove
          </button>
          </div>
        </div>
      </div>


      <!-- <div class="pe-f-product" [ngStyle]="{alignItems:cs.alignToFlex(item.data.align)}" *ngFor="let product of item.data.products">      
        <img class="pe-f-p-image" [src]="product.image"  (click)="viewOnly && fn_ViewProduct(storeName,product.ProductId, product.DesignId, 1)">

        <div class="pe-f-p-name">{{ product.name}}</div>
        <div class="pe-f-p-desc">{{product.desc}}</div>
        <div class="pe-f-p-price">{{product.price | currency:'USD':'symbol':'1.2-4'}}</div>
        <button [disabled]="!product.ProductId" *ngIf="!viewOnly" mat-button type="button"
                class="mat-btn mat-back" title="Buy Now">
          Buy Now
        </button>
        <button [disabled]="!product.ProductId" *ngIf="viewOnly" mat-button type="button"
                (click)="fn_ViewProduct(storeName,product.ProductId, product.DesignId, 1)"
                class="mat-btn mat-back" title="Buy Now">
          Buy Now
        </button>
        <br />
        <button [disabled]="!product.ProductId" *ngIf="!viewOnly"
                mat-button type="button" class="mat-btn mat-red"
                (click)="fn_RemoveProduct(product.ProductId, product.DesignId)" title="Buy Now" style="margin-top:5px;">
          Remove
        </button>
      </div> -->
    </div>
  </app-sub-component-container>

</div>
